import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import formStyles from "@/styles/Form.module.scss";
import { Button } from "../Buttons";
import { useEffect, useRef } from "react";
import { TextField } from "../Form/Parts";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import yupNickNameValidate from "@/lib/yupNickNameValidate";
import classnames from "classnames";

yupNickNameValidate(y);
const schema = y.object().shape({
  nickName: y
    .string()
    .nickName("ニックネーム")
    .min(2, "ニックネームは2文字以上、20文字以内で入力してください。")
    .max(20, "ニックネームは2文字以上、20文字以内で入力してください。")
    .required("ニックネームが入力されていません。"),
});

const NickNameInputModal = ({ handleClick, modalCloseHandle }) => {
  const { formState, register, handleSubmit, setFocus } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
  });
  const { isValid, isSubmitting, errors } = formState;
  const nickNameRef = useRef(null);
  useEffect(() => {
    setFocus("nickName");
  }, [setFocus]);
  return (
    <>
      <div className={modalStyles.container}>
        <form onSubmit={handleSubmit(handleClick)} noValidate>
          <header>
            <h2>ニックネームの設定</h2>
          </header>
          <p className={modalStyles.guideLineText}>
            チャット時のニックネームを設定してください。
          </p>
          <fieldset className={formStyles.basicFieldset}>
            <TextField
              {...register("nickName")}
              className={classnames(modalStyles.nickNameInput, {
                [modalStyles.isError]: !isValid,
              })}
              title="ニックネーム"
              type="text"
              name="nickName"
              defaultValue=""
              placeholder="2文字以上20文字以内で入力してください"
              error={errors.nickName?.message}
              required
            />
          </fieldset>

          <Button
            type="button"
            onClick={handleSubmit(handleClick)}
            fillWhiteColor
            fontFixed
            large
            disabled={!isValid}
            disabledWithGray
            loading={isSubmitting}
          >
            確定
          </Button>
        </form>
        <Button
          type="button"
          fontFixed
          large
          borderLight
          onClick={modalCloseHandle}
        >
          閉じる
        </Button>
      </div>
    </>
  );
};

export default NickNameInputModal;
